'use client';

import { usePathname } from 'next/navigation';
import Header from './Header';
import Footer from './Footer';

interface ConditionalLayoutProps {
  children: React.ReactNode;
}

const ConditionalLayout = ({ children }: ConditionalLayoutProps) => {
  const pathname = usePathname();

  // Admin/dashboard routes that should NOT show public header/footer
  const adminRoutes = [
    '/cms-dashboard',
    '/admin/dashboard',
    '/lead-assignment',
    '/sales-dashboard',
    '/inquiry-management',
    '/lms-dashboard',
    '/dashboard'
  ];

  const isAdminRoute = adminRoutes.some(route => pathname?.startsWith(route));

  if (isAdminRoute) {
    // Admin pages: no header/footer
    return <>{children}</>;
  }

  // Public pages: show header and footer
  return (
    <>
      <Header />
      {children}
      <Footer />
    </>
  );
};

export default ConditionalLayout;